import * as React from 'react'

import { getSelectedLibrary } from '@disco/state-management/selectors/app'

import type { PlaylistId } from 'types/playlist'

import { useSelector } from 'hooks/use-redux'

import PlaylistDropdown from './playlist-dropdown'

type Props = {
  playlist: { playlist_id: PlaylistId }
  hideShare?: boolean
  onPlaylistSettingsAwait: () => void
}

/**
 * The playlist menu items, shared by the three-dot menu and the row's
 * right-click menu so the two can never drift apart.
 */
const PlaylistMenuBody = ({
  playlist,
  hideShare,
  onPlaylistSettingsAwait,
}: Props): React.ReactNode => {
  const selectedLibrary = useSelector(getSelectedLibrary)

  return (
    <PlaylistDropdown
      group={selectedLibrary}
      playlist={playlist}
      addToCustomGroup
      addToShortlist
      deletePlaylist
      downloadZip
      editMetadata
      editPlaylist
      playlistStats
      sharePlaylist={!hideShare}
      trackOrder
      onPlaylistSettingsAwait={onPlaylistSettingsAwait}
    />
  )
}

export default PlaylistMenuBody
